export default __webpack_public_path__ + "static/media/14.bf1c39af.jpg";